import { render, staticRenderFns } from "./VuesticPalletCustom.vue?vue&type=template&id=3d6ff2d0&"
import script from "./VuesticPalletCustom.vue?vue&type=script&lang=js&"
export * from "./VuesticPalletCustom.vue?vue&type=script&lang=js&"
import style0 from "./VuesticPalletCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticPalletCustom.vue"
export default component.exports